import {Component, forwardRef, Input, ChangeDetectionStrategy} from '@angular/core';

import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule
} from "@angular/forms";
import {IconComponent} from "../icon/icon.component";
import {config} from "../../../../config";

@Component({
    selector: 'app-countable-textarea',
    templateUrl: './countable-textarea.component.html',
    imports: [
    FormsModule,
    IconComponent,
    ReactiveFormsModule
],
    styleUrl: './countable-textarea.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => CountableTextareaComponent),
        }
    ]
})
export class CountableTextareaComponent implements ControlValueAccessor {
  @Input() public control!: FormControl | AbstractControl;
  @Input() public minCharacters: number = 0;
  @Input() public maxCharacters: number = config.textMaxCharacterCount;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onChange: (value: string) => void = () => {
  };
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouch: () => void = () => {
  };
  public value: string = "";
  public disabled: boolean = false;

  public formIsInvalid(): boolean {
    if (this.characterCount > this.maxCharacters) {
      return true;
    }
    return this.characterCount < this.minCharacters;
  }

  public get characterCount(): number {
    return this.value?.trim().length ?? 0;
  }

  public registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public writeValue(obj: string): void {
    this.value = obj;
  }
}
